import clsx from 'clsx';
import ScoringCategoryCombobox from 'components/comboboxes/ScoringCategoryCombobox';
import MutedText from 'components/common/MutedText';
import { HubertSlider } from 'components/HubertUI/HubertSlider';
import { Collapsible, Label } from 'radix-ui';
import { useState } from 'react';
import { useQuestionEditorContext } from '../../../context/create-question.context';

import { useAppDispatch, useAppSelector } from 'rtk/query/hooks';

import { updateDefaultScoringCategory, updateDefaultWeight } from 'rtk/Question.Editor.Slice';
import { selectQuestionInTemplateEditAndUneditable } from 'rtk/questionEditorSelector';
import UneditableInfoTooltip from '../../../UneditableInfoTooltip';
import { useTranslation } from 'react-i18next';

const DefaultEvaluationOpen = () => {
  const { t } = useTranslation('Questionsv2');
  const dispatch = useAppDispatch();
  const { questionId } = useQuestionEditorContext();

  const weight = useAppSelector((state) => state.questionEditor.byId[questionId].weight);
  const scoringCategory = useAppSelector((state) => state.questionEditor.byId[questionId].scoring_category);
  const inTemplateEditAndUneditable = useAppSelector((state) =>
    selectQuestionInTemplateEditAndUneditable(state, questionId),
  );
  const [tempWeight, setTempWeight] = useState<number>(weight ?? 0);
  const isKnowledgeCase: boolean = scoringCategory && scoringCategory === 'knowledge_case' ? true : false;
  const isWeightDisabled: boolean = isKnowledgeCase ? true : false;

  return (
    <Collapsible.Root className={`p-1`} defaultOpen={true}>
      <div className="mb-1 flex flex-row justify-between">
        <Collapsible.Trigger>
          <Label.Root className="cursor-pointer text-sm font-medium" htmlFor="create-question-text">
            {t('defaultEvaluation.label')}
            <MutedText text={` - ${t('defaultEvaluation.description')}`} />
          </Label.Root>
        </Collapsible.Trigger>
      </div>

      <Collapsible.Content className={`flex flex-col gap-2`}>
        <UneditableInfoTooltip disabled={inTemplateEditAndUneditable}>
          <ScoringCategoryCombobox
            disabled={inTemplateEditAndUneditable}
            onValueChange={(value) => {
              if (!value?.length) return;
              dispatch(updateDefaultScoringCategory({ questionId, category: value as string }));
              if (value === 'knowledge_case') {
                setTempWeight(0);
                dispatch(updateDefaultWeight({ questionId, weight: 0 }));
              }
            }}
            // @ts-ignore
            value={scoringCategory}
          />
        </UneditableInfoTooltip>

        <div className={clsx('hover:bg-neutral-purple', 'pt-[8px] pr-[12px] pb-[8px] pl-[12px]', 'rounded-md')}>
          <Label.Root className="hubert-vertical-center mb-1 flex flex-row text-sm font-medium" htmlFor="job-threshold">
            {t('defaultEvaluation.weightLabel')}
            <MutedText text={` - ${t('defaultEvaluation.weightDescription')}`} />
          </Label.Root>

          <div className="flex w-[75%] flex-row">
            <UneditableInfoTooltip disabled={inTemplateEditAndUneditable ?? isWeightDisabled}>
              <HubertSlider
                disabled={isWeightDisabled ?? inTemplateEditAndUneditable}
                min={0}
                max={1}
                step={0.01}
                // @ts-ignore
                value={[weight]}
                onValueChange={(value: number[]) => {
                  setTempWeight(value[0]);
                  dispatch(updateDefaultWeight({ questionId, weight: value[0] }));
                }}
              />
            </UneditableInfoTooltip>
            <div className="bg-info-500 ml-1 flex h-6 w-6 items-center justify-center rounded-full text-white">
              {/* <p>{q.weight * 100}</p> */}
              <div>{(tempWeight * 100).toFixed(0)}</div>
            </div>
          </div>
        </div>
      </Collapsible.Content>
    </Collapsible.Root>
  );
};

export default DefaultEvaluationOpen;
